<template>
  <article>
    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap>
          <v-flex lg9>
            <p class="table_card__head--title">
              {{ sublocation_name }}
            </p>
            <v-breadcrumbs class="breadcums">
              <v-icon slot="divider">chevron_right</v-icon>
              <v-breadcrumbs-item
                v-if="getUserType() !== 'Counter'"
                @click="$router.push({name: 'access'})"
                class="breadcums__option"
              >
                Resumen
              </v-breadcrumbs-item>
              <v-breadcrumbs-item
                @click="$router.push({name: 'location_access', params: {id: location_id}})"
                class="breadcums__option"
              >
                {{ sublocation_name }}
              </v-breadcrumbs-item>
              <v-breadcrumbs-item
                disabled
                class="breadcums__disable"
              >
                Calendario
              </v-breadcrumbs-item>
            </v-breadcrumbs>
          </v-flex>
          <v-flex lg3 class="filter_options">
            <div
              class="buttom_reload"
              @click="getScheduleDays()"
            >
              <img src="@/assets/img/icons/refresh-icon.svg">
            </div>
          </v-flex>
        </v-layout>
      </div>
      
      <div class="table_card__body">
        <div class="structure_date">          
          <div class="structure_date__month_select">  
            <p>Selecciona la fecha</p>          
            <select name="" id="" class=""
                v-model="myActualDate.month"
                @change="getScheduleDays()">
                <option v-for="(mon,index) in three_month"
                    :value="mon.value"
                    :key="index">
                    {{ mon.name }}
                </option>
            </select>
          </div>
        </div>
        <calendar v-if="is_changed"
          :currentMonth="selectDate"
          :unprocessedTurns="this.turns"
          :propsMonth="this.myActualDate.month"
          :propsYear="this.new_year"
          :sublocation_id="this.params_sublocation_id"
          :timezome="this.timezone"
          :propsInvalidDays="this.invalid_days"
          @canceled-booking="updateCalendar"
        />
      </div>      
    </div>    
  </article>
</template>

<script>
import Calendar from './../../../../shared/Calendar.vue';
import moment from 'moment';
export default {
  data(){
    return{
      date: localStorage.getItem("mySelectedDate")?localStorage.getItem("mySelectedDate"):new moment().format("YYYY-MM"),
      user:{
        name: '',
        last_name:'',
        id_card:'',
        card_company:''
      },
       table:{
        total: 0,
        month:{
          total:0,
          diurnal:0,
          nocturn:0
        }
      },
      guards:[],
      unprocessedTurns:[
      ],
      prevRoute:'',
      three_month: [],
      months: [
        { id:  1, value: '01', name: 'Enero'      },
        { id:  2, value: '02', name: 'Febrero'    },
        { id:  3, value: '03', name: 'Marzo'      },
        { id:  4, value: '04', name: 'Abril'      },
        { id:  5, value: '05', name: 'Mayo'       },
        { id:  6, value: '06', name: 'Junio'      },
        { id:  7, value: '07', name: 'Julio'      },
        { id:  8, value: '08', name: 'Agosto'     },
        { id:  9, value: '09', name: 'Septiembre' },
        { id: 10, value: '10', name: 'Octubre'    },
        { id: 11, value: '11', name: 'Noviembre'  },
        { id: 12, value: '12', name: 'Diciembre' },
      ],
      myActualDate:{day:0,month:0,year:0},
      myOriginDate:{month:0,year:0},
      params_sublocation_id: '',
      is_changed: false,
      new_year: 0,
      timezone: '',
      invalid_days: [],
      location_id: '',
      sublocation_name: ''
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(from.name!="GuardTurn"){
        vm.prevRoute = from.path;
        localStorage.setItem("calendarRoute",from.path)
      }
    })
  },
  components:{
    'calendar':Calendar,
  },
  mounted(){
    if (this.$route.params.id > 0) {
      // console.log('Es Mayor que 0 ', this.$route.params.id)
      this.updateSublocationId(this.$route.params.id)
      this.location_id = this.$route.params.location_id
      this.sublocation_name = this.$route.params.sublocation_name
    }
    this.threeMonth();
    this.cargeDate();
    this.getScheduleDays();
  },
  computed:{
    isActualDate(){
      return this.myActualDate.year==this.myOriginDate.year&&this.myActualDate.month==this.myOriginDate.month
    },
    turns: function(){
      return this.unprocessedTurns
    },
    selectedDate: function(){
      return moment(this.date).lang('es').format('MMMM YYYY');
    },
    selectDate: function(){
        return this.myActualDate.year + "-" + this.myActualDate.month
    }
  },
  methods:{
    threeMonth(){
        let date = new Date();
        this.months
        let index = date.getMonth()
        for(let i = 1;i <= 3; i++){
        if (index > 11) {
            index = 0
        }
        this.three_month.push(this.months[index])
        index += 1
        }
    },
    cargeDate(){
        let s_date = new Date()
        let clientOffset = new Date().getTimezoneOffset()
        let ans = new Date(s_date.getTime() - (clientOffset*60000))
        var zoneActualDate = ans.toISOString().substr(0, 10).split("-")
        this.myOriginDate.year= Number(zoneActualDate[0])
        this.myOriginDate.month= zoneActualDate[1]
        this.myOriginDate.day=zoneActualDate[2]
        this.myActualDate.year = Number(zoneActualDate[0])
        this.myActualDate.month = zoneActualDate[1]
        this.myActualDate.day = zoneActualDate[2]
    },
    getScheduleDays(){
        var vm = this;
        vm.new_year = vm.myActualDate.year
        if(vm.three_month[0].id > 10) {
            if(vm.myActualDate.month < 10 && vm.myActualDate.month > 0){
                vm.new_year = vm.myActualDate.year + 1
            }
        }
        console.log("sublocation id!!!", vm.getSublocationId())
        try{
            vm.$http.get('app/bookings/schedule_days_sublocation', {
                headers: {
                    "X-Device-ID" : this.getDeviceId(),
                    "Authorization" : 'Bearer ' + this.getUserToken()
                },
                params:{
                    sublocation_id: this.getSublocationId(),
                    actual: vm.isActualDate,
                    day: vm.myActualDate.day,
                    month: vm.myActualDate.month,
                    year: vm.new_year
                }
            }).then(function(response){
                vm.is_changed = false
                vm.select_days = response.body;
                vm.invalid_days = response.body.invalid_days;
                vm.unprocessedTurns=response.body.bookings;
                vm.is_changed = true
                if(response.body.meta != undefined && response.body.meta != null){
                    if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                        this.checkToken(response.body.meta.authentication_token)
                    }
                }
            }, function(response){
                if(response.body.meta != undefined && response.body.meta != null){
                    if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                        this.checkToken(response.body.meta.authentication_token)
                    }
                }
                console.log("Respuesta error de reservas");
                if (response.status==401) {
                    // this.updateAlertMessage(response.body.errors[0].details, "Un momento...");
                    this.updateAlertMessage("Tienes una sesión abierta en otro dispositivo.", "Un momento...");
                    this.updateIsInAlert(true)
                }else{
                    this.updateAlertMessage(response.body.errors[0].details);
                    this.updateIsInAlert(true)
                }
            });
        }catch(e){
            console.log("Fallo reservas home");
            this.updateAlertMessage(e.message);
        }
        vm.is_changed = false;
    },
    updateCalendar(booking){
      if(booking){
        this.getScheduleDays();
      }        
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/locations/sublocations/bookings/CalendarBooking.vue